import EmptyState from '@/components/EmptyState';
import { useArchivedProducts, useRestoreProduct } from '@/features/menu/hooks/useMenu';
import { useT } from '@/i18n';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { loc } from '@/utils/localized';
import { formatMoney } from '@/utils/money';
import {
  Block,
  BlockFooter,
  Button,
  List,
  ListItem,
  Navbar,
  Page,
  Preloader,
  f7,
} from 'framework7-react';

export function ArchivedProductsPage({ f7route }: { f7route: { params: { menuId: string } } }) {
  const t = useT();
  const { menuId } = f7route.params;
  const { data: products, isLoading } = useArchivedProducts(menuId);
  const restore = useRestoreProduct();
  const currency = useRestaurantStore((s) => s.restaurantConfig?.currency) ?? 'EUR';

  const onRestore = (productId: string) => {
    restore.mutate(
      { productId },
      {
        onSuccess: () => f7.toast.show({ text: t.menu.itemRestored, closeTimeout: 2000 }),
      },
    );
  };

  return (
    <Page name="archived-products">
      <Navbar title={t.menu.archivedItemsTitle} backLink={t.back} />
      {isLoading ? (
        <Block style={{ textAlign: 'center' }}>
          <Preloader />
        </Block>
      ) : !products || products.length === 0 ? (
        <Block>
          <EmptyState icon="archivebox" title={t.menu.archivedItemsEmpty} />
        </Block>
      ) : (
        <>
          <BlockFooter>{t.menu.archivedItemsHint}</BlockFooter>
          <List strong dividersIos insetMd>
            {products.map((p) => (
              <ListItem key={p.id} title={loc(p.name)} after={formatMoney(p.price, currency)}>
                <Button
                  slot="after"
                  small
                  disabled={restore.isPending}
                  onClick={() => onRestore(p.id)}
                >
                  {t.menu.restore}
                </Button>
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Page>
  );
}
